import qfSignals from "quickfire/qf-signals";
import { VEventEnum } from "quickfire/v/enums";

export function QuickfireStartRound() {
    qfSignals.dispatch(VEventEnum.gameplayStart);
}
